import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import AgentChat from '../../../AgentChat';
import {expenseActions} from '../../../../state/actions/expense.actions';
import {agentWebsocketFlowConstants, expenseAgentTypeConstants} from '../../../../constants';
import {alertActions} from '../../../../state/actions/alert.actions';

const ExpenseAgentChat = ({
  dispatch,
  closeAgent,
  onClose,
  open = false,
  variant = expenseAgentTypeConstants.ADD_NEW_EXPENSE,
  query = {},
  ...rest
}) => {
  const [t] = useTranslation('expenses');

  const chatProps = useMemo(() => ({
    [expenseAgentTypeConstants.ADD_NEW_EXPENSE]: {
      flow: agentWebsocketFlowConstants.EXPENSE_SUBMISSION,
      title: t('agentChat.newExpense.title'),
      welcomeText: t('agentChat.newExpense.welcomeText'),
    },
    [expenseAgentTypeConstants.FILL_MISSING_INFO]: {
      flow: agentWebsocketFlowConstants.MISSING_INFO,
      title: t('agentChat.fillMissingInfo.title'),
      welcomeText: t('agentChat.fillMissingInfo.welcomeText'),
    },
  }[variant] || {}), [variant, t]);


  const handleClose = (props) => {
    const flow = chatProps?.flow;
    const confirmed = props?.confirmed || false;
    if (flow && confirmed) {
      const alertMessage = {
        [agentWebsocketFlowConstants.MISSING_INFO]: t('agentChat.fillMissingInfo.closeSuccessText'),
        [agentWebsocketFlowConstants.EXPENSE_SUBMISSION]: t('agentChat.newExpense.closeSuccessText'),
      }[flow] || null;
      if (alertMessage) alertActions.success(alertMessage, 4000, 350);
    }

    closeAgent();
    onClose?.(props);
  }

  return (
    <AgentChat
      open={open}
      onClose={handleClose}
      query={query}
      {...chatProps}
      {...rest}
    />
  );
}

ExpenseAgentChat.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
  variant: PropTypes.oneOf(Object.values(expenseAgentTypeConstants)),
}

const mapStateToProps = ({ expense: { agentChatProps } }) => ({
  open: agentChatProps.open,
  variant: agentChatProps.variant,
  query: agentChatProps.query,
});

const mapDispatchToProps = {
  closeAgent: expenseActions.closeExpenseAgentChat
}

export default connect(mapStateToProps, mapDispatchToProps)(ExpenseAgentChat);
